import { useSelector } from 'react-redux'
import useFindItemByUnit from '../useFindItemByUnit'

const getLineUnitQty = (el) =>
  (parseFloat(el?.quantity) || 0) * useFindItemByUnit(el, el?.currentUnit)

const getLineUnitPrice = (el) =>
  parseFloat(el?.spoPrice || el?.SPOPrice || el?.marketPriceCP) || 0

const getLineIvaRate = (el) => {
  const raw = el?.IVACP ?? el?.IVA ?? 0
  const n = parseFloat(raw)
  return Number.isFinite(n) ? n : 0
}

const getLineGross = (el) => getLineUnitPrice(el) * getLineUnitQty(el)

const getLineNet = (el) => {
  const gross = getLineGross(el)
  const iva = getLineIvaRate(el)
  return (gross / (100 + iva)) * 100
}

const useCalculateSaleCart = () => {
  const allItemsUpdatedCart = useSelector((state) => state.saleCart.saleCart)

  const percentageOrder = {
    pickUp: 15,
    payOnline: 1.5,
    creditLine: 1,
  }

  const totalPriceNonIVA = (allItemsUpdatedCart || []).reduce(
    (acc, el) => acc + getLineNet(el),
    0,
  )
  const totalPrice = (allItemsUpdatedCart || []).reduce(
    (acc, el) => acc + getLineGross(el),
    0,
  )
  const IVA = totalPrice - totalPriceNonIVA
  const deliveryPrice = 0

  const pickUpPrice = {
    total: totalPrice - (totalPrice / 100) * percentageOrder.pickUp,
    save: (totalPrice / 100) * percentageOrder.pickUp,
  }
  const payOnlinePrice = {
    total: totalPrice - (totalPrice / 100) * percentageOrder.payOnline,
    save: (totalPrice / 100) * percentageOrder.payOnline,
  }
  const CreditLinePrice = {
    total: totalPrice - (totalPrice / 100) * -percentageOrder.creditLine,
    save: (totalPrice / 100) * percentageOrder.creditLine,
  }

  return {
    totalPriceNonIVA,
    IVA,
    deliveryPrice,
    totalPrice,
    pickUpPrice,
    payOnlinePrice,
    CreditLinePrice,
    percentageOrder,
  }
}

export default useCalculateSaleCart
